/**
 * Shared perform-control layout constants.
 * Kept out of `preload-transition-buttons.tsx` so that module can fast-refresh as a component-only file.
 */

/** Fixed width for Open full panel + Preload/Transition so outline/contained match */
export const PRELOAD_TRANSITION_BUTTON_MIN_WIDTH_PX = 172;

/** Shared dimensions: same rendered width for both buttons at every breakpoint */
export const performControlActionButtonSx = {
  width: { xs: '100%', sm: PRELOAD_TRANSITION_BUTTON_MIN_WIDTH_PX },
  minWidth: { xs: 0, sm: PRELOAD_TRANSITION_BUTTON_MIN_WIDTH_PX },
  maxWidth: '100%',
  boxSizing: 'border-box' as const,
  justifyContent: 'center',
  textAlign: 'center',
} as const;

/** Perform transport + footer icon buttons (overlay and narrow control tab). */
export const performTransportIconButtonSx = {
  '& .MuiSvgIcon-root': {
    fontSize: '1.5rem',
  },
} as const;
